import { render, staticRenderFns } from "./ReactionButton.vue?vue&type=template&id=25dcab64&scoped=true&"
import script from "./ReactionButton.vue?vue&type=script&lang=js&"
export * from "./ReactionButton.vue?vue&type=script&lang=js&"
import style0 from "./ReactionButton.vue?vue&type=style&index=0&id=25dcab64&lang=scss&scoped=true&"
import style1 from "./ReactionButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dcab64",
  null
  
)

/* custom blocks */
import block0 from "./ReactionButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports